import React from 'react'
import NavigationLinks from './NavigationLinks'
import { DesktopMenu } from './DesktopMenu'
import { useMenuQuery } from '../../hooks/useMenuQuery'

import './navigation.scss'

const Navigation = ({ menu, pageContext = {}, isAkutrutaActive, secondaryMenu, logoSrc}) => {
  const { id } = pageContext || {}
  const { menu: filteredMenu } = useMenuQuery(id)

  return (
    <div className="nav">
      <ul className="nav__ul">
      {id && (id === 'dGVybToxMjk5MQ==') ? (
          filteredMenu?.map((mainItem) => (
            <NavigationLinks key={mainItem.id} navItem={mainItem} />
          ))
        ) : (
          menu?.map((mainItem) => (
            <NavigationLinks key={mainItem.id} navItem={mainItem} />
          ))
        )}
        <DesktopMenu isAkutrutaActive={isAkutrutaActive} menu={secondaryMenu} logoSrc={logoSrc}/>
      </ul>
    </div>
  )
}

export default Navigation
